import React, { useRef, useState, useEffect, useCallback } from "react";
import atomGif from "@/assets/images/aicopy/atom.gif";
import styles from "./index.module.less";

/** 两段文案之间的间隔（px），用于首尾相连轮播 */
const MARQUEE_GAP_PX = 24;

function getMarqueeDurationSec(textWidthPx) {
  const loop = textWidthPx + MARQUEE_GAP_PX;
  return Math.max(12, Math.min(60, loop / 28));
}

export default function AiWorkingStatusBadge({ label }) {
  const viewportRef = useRef(null);
  const measureRef = useRef(null);
  const [shouldMarquee, setShouldMarquee] = useState(false);
  const [durationSec, setDurationSec] = useState(16);
  const [prefersReducedMotion, setPrefersReducedMotion] = useState(false);

  const displayLabel = String(label || "").trim();

  useEffect(() => {
    if (typeof window === "undefined" || !window.matchMedia) return undefined;
    const mq = window.matchMedia("(prefers-reduced-motion: reduce)");
    const update = () => setPrefersReducedMotion(mq.matches);
    update();
    if (mq.addEventListener) {
      mq.addEventListener("change", update);
      return () => mq.removeEventListener("change", update);
    }
    mq.addListener(update);
    return () => mq.removeListener(update);
  }, []);

  const checkOverflow = useCallback(() => {
    const viewport = viewportRef.current;
    const measure = measureRef.current;
    if (!viewport || !measure) return;

    const viewW = viewport.clientWidth;
    const textW = measure.scrollWidth;
    const overflow = textW > viewW + 1;
    setShouldMarquee(overflow);
    if (overflow) {
      setDurationSec(getMarqueeDurationSec(textW));
    }
  }, []);

  useEffect(() => {
    checkOverflow();
    const viewport = viewportRef.current;
    if (!viewport || typeof ResizeObserver === "undefined") return undefined;
    const ro = new ResizeObserver(checkOverflow);
    ro.observe(viewport);
    return () => ro.disconnect();
  }, [displayLabel, checkOverflow]);

  if (!displayLabel) return null;

  const marqueeActive = shouldMarquee && !prefersReducedMotion;

  return (
    <div className={styles.badge} aria-label={displayLabel}>
      <img src={atomGif} alt="" className={styles.atomIcon} aria-hidden />
      <div className={styles.labelViewport} ref={viewportRef}>
        <span ref={measureRef} className={styles.labelMeasure} aria-hidden>
          {displayLabel}
        </span>
        {marqueeActive ? (
          <div
            className={styles.marqueeTrack}
            style={{ "--marquee-duration": `${durationSec}s` }}
            aria-hidden
          >
            <span className={styles.marqueeUnit}>
              <span className={styles.marqueeSegment}>{displayLabel}</span>
              <span className={styles.marqueeGap} aria-hidden />
            </span>
            <span className={styles.marqueeUnit} aria-hidden>
              <span className={styles.marqueeSegment}>{displayLabel}</span>
              <span className={styles.marqueeGap} aria-hidden />
            </span>
          </div>
        ) : (
          <span className={styles.labelStatic}>{displayLabel}</span>
        )}
      </div>
    </div>
  );
}
